import React, { useState, useEffect, useMemo } from "react";
import "./PortfolioSection.css";
import pngImage from "../assets/portfolio.png"
import jpgImage from "../assets/portfolio.jpg"
import beautyImage from "../assets/7p_beauty/1.jpg"; // 뷰티 이미지
import hairSalonImage from "../assets/8p_salon/1.jpg"; // 미용실 이미지
import restaurantImage from "../assets/9P_restaurant/1.jpg"; // 맛집 이미지
import hospitalImage from "../assets/10p_hospital/1.jpg"; // 병의원 이미지
import massageImage from "../assets/11p_massage/1.jpg"; // 마사지 이미지

function PortfolioSection() {
  const [activeCategory, setActiveCategory] = useState("뷰티");
  const [isLoaded, setIsLoaded] = useState(false); // Preloading 완료 상태

  // Use useMemo to memoize the categories array
  const categories = useMemo(
    () => [
      { name: "뷰티", image: beautyImage },
      { name: "미용실", image: hairSalonImage },
      { name: "맛집", image: restaurantImage },
      { name: "병의원", image: hospitalImage },
      { name: "마사지", image: massageImage },
    ],
    [] // Dependencies are empty as these values are static
  );

  // Preload Images
  useEffect(() => {
    const preloadImages = () => {
      categories.forEach((category) => {
        const img = new Image();
        img.src = category.image;
        img.onload = () => {
          setIsLoaded(true); // 이미지가 로드되었을 때 상태 업데이트
        };
      });
    };

    preloadImages();
  }, [categories]); // Now, 'categories' is memoized and won't cause unnecessary re-renders

  const handleCategoryClick = (categoryName) => {
    setActiveCategory(categoryName);
  };

  return (
    <section className="portfolio-section">
      <div className="portfolio-png-container">
        <img src={pngImage} alt="포트폴리오 텍스트" />
      </div>
      <div className="portfolio-jpg-container">
        <img src={jpgImage} alt="포트폴리오 설명"/>
      </div>
      <div className="portfolio-categories">
        {categories.map((category) => (
          <button
            key={category.name}
            className={`portfolio-button ${
              activeCategory === category.name ? "active" : ""
            }`}
            onClick={() => handleCategoryClick(category.name)}
          >
            {category.name}
          </button>
        ))}
      </div>
      <div className="portfolio-image-container">
        {isLoaded ? (
          <img
            src={
              categories.find((category) => category.name === activeCategory)
                .image
            }
            alt={activeCategory}
            className="portfolio-image"
          />
        ) : (
          <div className="loading-placeholder">이미지가 준비중입니다...</div> // 로딩 중 보여줄 UI
        )}
      </div>
    </section>
  );
}

export default PortfolioSection;
